import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MoneyInputDirective } from '../../directives/money-input.directive';
import { MaterialModule } from '../../material/material.module';

import { PaymentsDashboardComponent } from './payments-dashboard/payments-dashboard.component';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { ReturnDetailComponent } from './return-detail/return-detail.component';

@NgModule({
  declarations: [
    PaymentsDashboardComponent,
    MakePaymentComponent,
    PaymentHistoryComponent,
    PaymentConfirmationComponent,
    ReturnDetailComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MoneyInputDirective
  ],
  exports: [RouterModule]
})
export class PaymentsModule { }
